export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.14-1312.31",
  commitId: "595edde3e8e23ba17ceeb868dd79771b403d5593",
  commitTime: "2026-05-14T13:12:31.000Z",
});
